import type { FC } from 'react';

import {
  Dialog,
  DialogCloseButton,
  DialogContent,
} from '@wwe-portal/ui/components/dialog';
import { Button } from '@wwe-portal/ui/components/button/button';
import { cn } from '@wwe-portal/ui/lib/lib';

export interface SubscriptionInterstitialDialogProps {
  title: string;
  description: string;
  open: boolean;
  onClose?: () => void;
  onGoToSubscription: () => void;
  buttonText: string;
  className?: string;
}
export const SubscriptionInterstitialDialog: FC<
  SubscriptionInterstitialDialogProps
> = ({
  title,
  description,
  open,
  onClose,
  onGoToSubscription,
  buttonText,
  className,
}) => {
  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) {
          onClose?.();
        }
      }}
      open={open}
    >
      <DialogContent
        className={cn(
          'z-dialog from-back800 to-back600 from-back200 to-back200 w-[310px] gap-6 bg-gradient-to-r px-4 py-8 md:w-[410px]',
          className
        )}
        data-id="subscription-interstitial-dialog"
        variant="dialog"
      >
        <div className="text-text300 relative flex flex-col gap-6">
          <div className="text-sm font-semibold">{title}</div>
          <div className="text-xs font-normal">{description}</div>
          <Button className="h-[46px]" onClick={onGoToSubscription}>
            {buttonText}
          </Button>
        </div>
        <DialogCloseButton onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
};
